import { render, staticRenderFns } from "./PredefinedStatusesList.vue?vue&type=template&id=3b99f880&scoped=true&"
import script from "./PredefinedStatusesList.vue?vue&type=script&lang=js&"
export * from "./PredefinedStatusesList.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedStatusesList.vue?vue&type=style&index=0&id=3b99f880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b99f880",
  null
  
)

export default component.exports